/** Only local app paths can be used as the destination after sign-in. */
export function loginDestination(next: unknown): string {
    if (typeof next !== 'string' || !next.startsWith('/') || /[\\\u0000-\u0020]/u.test(next)) return '/home';
    try {
        const target = new URL(next, 'https://atlas.invalid');
        if (target.origin !== 'https://atlas.invalid' || target.pathname.startsWith('//') || /^\/login\/?$/iu.test(target.pathname)) return '/home';
        return target.pathname + target.search + target.hash;
    } catch {
        return '/home';
    }
}
